import { render } from "./DaftarKonten.vue?vue&type=template&id=17a613b1"
import script from "./DaftarKonten.vue?vue&type=script&lang=js"
export * from "./DaftarKonten.vue?vue&type=script&lang=js"

import "./DaftarKonten.vue?vue&type=style&index=0&id=17a613b1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__